import React, { useState } from "react";
import styles from "./Tools.module.css";
import CryptoJS from "crypto-js";
import { reverseHex } from "../../Common";

const ScriptPubkeyHash = () => {
  const [scriptPubKey, setScriptPubKey] = useState("");
  const [result, setResult] = useState("");
  const [finalResult, setFinalResult] = useState("");

  const generateHash = async () => {
    try {
      const wordArray = CryptoJS.enc.Hex.parse(scriptPubKey);
      const hashHex = CryptoJS.SHA256(wordArray).toString(CryptoJS.enc.Hex);
      const revHex = reverseHex(hashHex);
      setResult(hashHex);
      setFinalResult(revHex);
    } catch (error) {
      setResult(`Error: ${error.message}`);
      setFinalResult("");
    }
  };

  return (
    <div className={`${styles.tools} times mbox`}>
        <h4 className="text-center" title="Convert ScriptPubKey (hex) to ScriptPubkeyHash (SHA256). The ScriptPubkeyHash is also known as ScriptHash.">
        <i className="bi bi-box-arrow-right" style={{ color: "brown" }}></i>{" "}
        Convert ScriptPubKey to ScriptPubkeyHash
        </h4>
        <hr />
            <table width="100%">
                <tbody>
                <tr style={{ height: 70 }}>
                <td>
                    <div className={`${styles.enterHex}`}>Enter ScriptPubKey Hex String: </div>
                    <div width="100%">
                    <input
                        type="text"
                        id="scriptPubKey"
                        value={scriptPubKey}
                        onChange={(e) => setScriptPubKey(e.target.value)}
                        style={{ width: "100%", padding: "8px", marginTop: "3px" }}
                        placeholder="Enter the scriptPubKey in hex format"
                        />
                    </div>
                </td>
                </tr>
                <tr>
                    <td>
                        <div>
                            <button className="btn btn-primary" style={{ width: "120px"}} title="Convert ScriptPubKey hex string to ScriptPubKeyHash (aka ScriptHash) by using SHA256. " onClick={generateHash}>Convert</button>
                        </div>
                    </td>
                </tr>
                <tr style={{ height: 70 }}>
                <td>
                    <div className="label">ScriptPubkeyHash (SHA256/little endian): </div>
                    <div width="100%">
                    <input
                        id="scriptPubKeyResult1"
                        readOnly={true}
                        type="text"
                        style={{ width: "100%", padding: "8px", marginTop: "3px", backgroundColor: "lightgray"}}
                        value={result}
                        />
                    </div>
                </td>
                </tr>
                <tr style={{ height: 70 }}>
                <td>
                    <div className="label">ScriptPubkeyHash (big endian for API client) </div>
                    <div width="100%">
                    <input
                        id="scriptPubKeyResult2"
                        readOnly={true}
                        type="text"
                        style={{ width: "100%", padding: "8px", marginTop: "3px", backgroundColor: "lightgray" }}
                        value={finalResult}
                        />
                    </div>
                </td>
                </tr>
                </tbody>
            </table>
    </div>
  );
};

export default ScriptPubkeyHash;
